/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramWhiteLabelsControllerFindOneQueryResponse,
  TelegramWhiteLabelsControllerFindOnePathParams,
  TelegramWhiteLabelsControllerFindOne404,
} from '../../types/TelegramWhiteLabelsControllerFindOne.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramWhiteLabelsFindOne } from '../../methods/telegramWhiteLabelsFindOne.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramWhiteLabelsFindOneQueryKey = (domain: TelegramWhiteLabelsControllerFindOnePathParams['domain']) =>
  [{ url: '/api/telegram/white-labels/:domain', params: { domain: domain } }] as const;

export type TelegramWhiteLabelsFindOneQueryKey = ReturnType<typeof telegramWhiteLabelsFindOneQueryKey>;

export function telegramWhiteLabelsFindOneQueryOptions(
  domain: TelegramWhiteLabelsControllerFindOnePathParams['domain'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramWhiteLabelsFindOneQueryKey(domain);
  return queryOptions<
    TelegramWhiteLabelsControllerFindOneQueryResponse,
    ResponseErrorConfig<TelegramWhiteLabelsControllerFindOne404>,
    TelegramWhiteLabelsControllerFindOneQueryResponse,
    typeof queryKey
  >({
    enabled: !!domain,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramWhiteLabelsFindOne(domain, config);
    },
  });
}

/**
 * {@link /api/telegram/white-labels/:domain}
 */
export function useTelegramWhiteLabelsFindOne<
  TData = TelegramWhiteLabelsControllerFindOneQueryResponse,
  TQueryData = TelegramWhiteLabelsControllerFindOneQueryResponse,
  TQueryKey extends QueryKey = TelegramWhiteLabelsFindOneQueryKey,
>(
  domain: TelegramWhiteLabelsControllerFindOnePathParams['domain'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramWhiteLabelsControllerFindOneQueryResponse,
        ResponseErrorConfig<TelegramWhiteLabelsControllerFindOne404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramWhiteLabelsFindOneQueryKey(domain);

  const query = useQuery(
    {
      ...telegramWhiteLabelsFindOneQueryOptions(domain, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramWhiteLabelsControllerFindOne404>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
